import Link from 'next/link';
import { Icon, Picture } from '@workspace/ui/common';
import { Typography } from '@workspace/ui/common/Typography/Typography';
import { DisplayProduct } from '../product-type.types';

interface ProductTypeCardProps {
  product: DisplayProduct;
  index: number;
}

export function ProductTypeCard({ product }: ProductTypeCardProps) {
  if (!product) return null;

  const rawThumbnail = product.thumbnailImage;
  const thumbnailImage = rawThumbnail?.image ?? rawThumbnail;

  const thumbnailAlt =
    thumbnailImage?.bynderImage?.alt || thumbnailImage?.alt || rawThumbnail?.imageDescription || product.name || '';

  return (
    <div className="group relative block bg-white items-center rounded-md duration-300 cursor-pointer border border-secondary-100">
      <div className="w-full md:h-72.5 h-61.25 bg-secondary-200 rounded-t-md flex items-center justify-center overflow-hidden">
        {thumbnailImage ? (
          <Picture
            image={thumbnailImage}
            alt={thumbnailAlt}
            desktopWidth={387}
            desktopHeight={290}
            className="w-full h-full"
            imgClassName="w-full h-full object-cover rounded-t-md transition-transform duration-300 ease-in-out group-hover:scale-[1.03]"
          />
        ) : (
          <div className="text-secondary-400 text-sm">Image Placeholder</div>
        )}
      </div>

      <div className="h-44 md:h-59.5 p-6 flex flex-col justify-between">
        <div>
          <Typography variant="h4" className="text-lg! line-clamp-1 md:line-clamp-2">
            {product.name}
          </Typography>

          {product.productSummary && (
            <Typography variant="bodySm" className="line-clamp-3 text-sm font-body! mt-2">
              {product.productSummary}
            </Typography>
          )}
        </div>

        <div className="flex justify-end items-center">
          <Link
            href={product.url || '#'}
            className="inline-flex items-center text-primary group-hover:text-primary-500 font-semibold! transition-colors duration-200 mr-2 font-heading text-base! after:absolute after:inset-0"
          >
            {product.link?.text || 'Learn more'}
          </Link>
          <Icon
            name="IconNextRed"
            size="24"
            className="transition-transform duration-300 ease-in-out group-hover:translate-x-1 text-primary"
          />
        </div>
      </div>
    </div>
  );
}
